
namespace TabAurous.Reports {
    import fld = TabAurous.Stock.StockItemRow.Fields;
    @Serenity.Decorators.registerClass()
    export class JewelleryMovementGrid extends _Ext.GridBase<TabAurous.Stock.StockItemRow, any> {
        protected getColumnsKey() { return 'Stock.JewelleryReport'; } 
        protected getIdProperty() { return TabAurous.Stock.StockItemRow.idProperty; }
        protected getInsertPermission() { return TabAurous.Stock.StockItemRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.Stock.StockItemRow.localTextPrefix; }
        protected getService() { return TabAurous.Stock.JewelleryMovementService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            (this.view.params as ReportFiltersRequest).ItemTypeId = 101;
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.addDateRangeFilter("VoucherDate", "Date");
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();


            //var plugin = new Slick.ColumnGroup();
            //grid.registerPlugin(plugin);
            //var columns = grid.getColumns();
            //plugin.enableColumnGrouping();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());


            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('Pieces'),
                    new Slick.Aggregators.Sum('Weight'),
                    new Slick.Aggregators.Sum('DiamondPieces'),
                    new Slick.Aggregators.Sum('DiamondWeight'),
                    new Slick.Aggregators.Sum('StonePieces'),
                    new Slick.Aggregators.Sum('StoneWeight'),
                    new Slick.Aggregators.Sum('OtherPieces'),
                    new Slick.Aggregators.Sum('OtherWeight')]
            });


            this.view.setGrouping([{
                formatter: g => { 
                    return "<span class='slick-group-title-header'>" +
                        g.value +
                        "<span class='slick-cell l7 r7'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.Pieces + "</span></span>" +
                        "<span class='slick-cell l8 r8'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.Weight.toFixed(3) + "</span></span>";
                },
                getter: 'ProductCode',
                displayTotalsRow: false,
            }])

            return grid;
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    
                    lookupKey: "AllProducts",
                    multiple: true

                },
                field: 'ProductId',
                title: 'Product',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).ProductIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },

                cssClass: 'hidden-xs'
            });


            return filters;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            
            return [({
                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {
                    
                    Common.ReportHelper.execute({
                        reportKey: 'Stock.JewelleryMovementRegister',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date:this.view.params.Criteria
                        }
                    });
                }
            }
            )]
        }
    }
}